import { SET_CURRENT_IMAGE_UPLOAD } from "./imageConstants";

export function setImageUploadAction(image) {
    return {
        type: SET_CURRENT_IMAGE_UPLOAD,
        image: image,
    };
}

export function uploadImage(image) {
    return (dispatch) => {
        dispatch(setImageUploadAction(image));
    };
}
